/**
 * Normaliza um valor (que pode chegar como array real ou string
 * JSON-encoded) em `string[]`. Retorna `null` quando o valor não é
 * conversível para lista — chamadores decidem o fallback (`[]` para
 * `extractList`, `''` para o branch de `interpolateString`).
 */
export function parseToStringList(value: unknown): string[] | null {
  if (Array.isArray(value)) {
    return value.map((entry) => String(entry));
  }

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) {
        return parsed.map((entry) => String(entry));
      }
    } catch {
      return null;
    }
  }

  return null;
}
